import React from 'react';
import { BarChart3, Activity, Database, Settings, TrendingUp } from 'lucide-react';

const AdminNav = ({ activeTab, onTabChange }) => {
  const tabs = [
    {
      id: 'overview',
      label: 'Overview',
      icon: BarChart3,
      description: 'Quick system health check'
    },
    {
      id: 'analytics',
      label: 'Usage Analytics',
      icon: TrendingUp,
      description: 'Platform-wide usage metrics'
    },
    {
      id: 'system',
      label: 'System Health',
      icon: Activity,
      description: 'Errors and monitoring'
    },
    {
      id: 'database',
      label: 'Database',
      icon: Database,
      description: 'Direct database access with audit logging'
    },
    {
      id: 'settings',
      label: 'Platform Settings',
      icon: Settings,
      description: 'System-wide configuration',
      disabled: true,
      comingSoon: true
    }
  ];

  return (
    <div className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <nav className="flex space-x-8 -mb-px" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            const isDisabled = tab.disabled;

            return (
              <button
                key={tab.id}
                onClick={() => !isDisabled && onTabChange(tab.id)}
                disabled={isDisabled}
                className={`
                  group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm
                  transition-colors duration-150
                  ${isActive
                    ? 'border-blue-500 text-blue-600'
                    : isDisabled
                    ? 'border-transparent text-gray-400 cursor-not-allowed'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
                aria-current={isActive ? 'page' : undefined}
              >
                <Icon
                  className={`
                    -ml-0.5 mr-2 h-5 w-5
                    ${isActive
                      ? 'text-blue-500'
                      : isDisabled
                      ? 'text-gray-400'
                      : 'text-gray-400 group-hover:text-gray-500'
                    }
                  `}
                />
                <span>{tab.label}</span>
                {tab.comingSoon && (
                  <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
                    Soon
                  </span>
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default AdminNav;
